<template>
  <div class="sleeve-patch-caption">
    <div class="row">
      <div class="col-xs-12">
        <input
          :name="selectedPatchCaptionLabelInputName"
          :value="patch.CaptionLabel"
          type="hidden"
        >
        <label
          class="sleeve-patch-caption__label"
          for="patch-caption"
        >
          <span
            v-if="patch.IsCaptionRequired"
            class="sleeve-patch-caption__required-symbol"
          >*</span>
          {{ patch.CaptionLabel }}
        </label>
        <div>
          <input
            id="sleeve-patch-caption-input"
            :name="selectedPatchCaptionInputName"
            v-model.trim="patchCaptionValue"
            :required="patch.IsCaptionRequired"
            type="text"
            class="sleeve-patch-caption__input js-caption-input"
            @focus="handleInputFocus"
          >
          <div
            v-if="patch.CaptionLength !== null"
            class="sleeve-patch-caption__counter"
          >
            {{ remainingCaptionChars }} characters left
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'SleevePatchCaption',
  props: {
    patch: { type: Object, default: null, required: true }
  },
  data () {
    return {
      patchCaptionValue: ''
    }
  },
  computed: {
    selectedPatchCaptionLabelInputName () {
      return `CaptionLabel_${this.firstOptionProduct.CatalogPackageOptionProductID}`
    },
    selectedPatchCaptionInputName () {
      return `Caption_${this.firstOptionProduct.CatalogPackageOptionProductID}`
    },
    firstOptionProduct () {
      return this.$store.state.catalogPageCommon.firstOptionProduct
    },
    remainingCaptionChars () {
      return this.patch.CaptionLength - this.patchCaptionValue.length
    }
  },
  watch: {
    patch (v, ov) {
      if (v.Id !== ov.Id) {
        this.patchCaptionValue = ''
      }
    },
    patchCaptionValue (v, ov) {
      if (
        this.patch.CaptionLength != null &&
        v.length > this.patch.CaptionLength
      ) {
        this.patchCaptionValue = ov
      }
    }
  },
  mounted () {
    const configuredText = this.$store.getters.getConfiguredValue(this.selectedPatchCaptionInputName)

    if (configuredText !== null && configuredText.length > 0) {
      this.patchCaptionValue = configuredText
    }
  },
  methods: {
    handleInputFocus () {
      GoogleAnalytics.trackEvent(
        'Patch Caption',
        'click',
        this.patch.CaptionLabel
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../PackageOptions/OptionProduct/scss/option-product.scss";

.sleeve-patch-caption {
  margin-bottom: 10px;

  @include option-product-form-elements-mixin;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/SleevePatchSelection/SleevePatchCaption.vue